import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppFloat } from "./WhatsAppFloat";
import { ChatWidget } from "./ChatWidget";

export const Layout = ({ children }) => {
    return (
        <>
            <Header />
            <main id="main" data-testid="main-content">
                {children}
            </main>
            <Footer />
            <WhatsAppFloat />
            <ChatWidget />
        </>
    );
};
